import { CatalogAdjustmentReasonPage } from "./CatalogAdjustmentReasonPage";

const CatalogAdjustmentReason = () => {
	return <CatalogAdjustmentReasonPage />;
};
export default CatalogAdjustmentReason;
